// カテゴリー
export const INCOME_TYPE = "収入";
export const EXPENSE_TYPE = "支出";

// 画面モード判定の基準
export const SP_SHORT_SIDE_MAX = 412;
export const SP_ASPECT_RATIO_MIN = 924 / 412;

export type Category = typeof INCOME_TYPE | typeof EXPENSE_TYPE;

export const normalizeType = (value: any): Category => {
  if (value === INCOME_TYPE || value === "income") return INCOME_TYPE;
  if (value === EXPENSE_TYPE || value === "expense") return EXPENSE_TYPE;
  return EXPENSE_TYPE;
};

export const FOOD_CATEGORY_LARGE = "食費";
export const DEPRECATED_DINING_CATEGORY_LARGE = "外食費";

export const normalizeCategoryLarge = (categoryLarge: string) =>
  categoryLarge === DEPRECATED_DINING_CATEGORY_LARGE
    ? FOOD_CATEGORY_LARGE
    : categoryLarge;

// 項目（大）
export const categoryLargeList = [
  { label: "案件収入", type: "収入", category: "案件収入" },
  { label: "副業収入", type: "収入", category: "副業収入" },
  { label: "その他収入", type: "収入", category: "その他収入" },

  { label: "住居費", type: "支出", category: "住居費" },
  { label: "水道光熱費", type: "支出", category: "水道光熱費" },
  { label: "通信費", type: "支出", category: "通信費" },
  { label: "スマホ代", type: "支出", category: "スマホ代" },
  { label: "保険料", type: "支出", category: "保険料" },
  { label: "税金", type: "支出", category: "税金" },
  { label: "社会保険料", type: "支出", category: "社会保険料" },
  { label: "確定拠出年金", type: "支出", category: "確定拠出年金" },
  { label: "旅費・交通費", type: "支出", category: "旅費・交通費" },
  { label: "学習費", type: "支出", category: "学習費" },
  { label: "食費", type: "支出", category: "食費" },
  {
    label: "日用品・消耗品費",
    type: "支出",
    category: "日用品・消耗品費",
  },
  { label: "接待・交際費", type: "支出", category: "接待・交際費" },
  { label: "医療費", type: "支出", category: "医療費" },
  { label: "美容・被服費", type: "支出", category: "美容・被服費" },
  { label: "特別・臨時費", type: "支出", category: "特別・臨時費" },
  { label: "娯楽費", type: "支出", category: "娯楽費" },
];

// 項目（小）
export const categorySmallList = [
  { label: "業務委託費(準委任)", type: "収入", category: "案件収入" },
  { label: "調整額", type: "収入", category: "案件収入" },
  { label: "代理店", type: "収入", category: "案件収入" },
  { label: "特別代理店", type: "収入", category: "案件収入" },
  { label: "コンサルタント", type: "収入", category: "案件収入" },
  { label: "3rdroom", type: "収入", category: "副業収入" },
  { label: "シティコム", type: "収入", category: "その他収入" },
  { label: "その他収入", type: "収入", category: "その他収入" },

  { label: "住居費", type: "支出", category: "住居費" },
  { label: "水道代", type: "支出", category: "水道光熱費" },
  { label: "電気代", type: "支出", category: "水道光熱費" },
  { label: "ガス代", type: "支出", category: "水道光熱費" },
  { label: "softbank光", type: "支出", category: "通信費" },
  { label: "My Softbank", type: "支出", category: "スマホ代" },
  { label: "個人年金保険", type: "支出", category: "保険料" },
  { label: "所得税", type: "支出", category: "税金" },
  { label: "住民税", type: "支出", category: "税金" },
  { label: "国民健康保険料", type: "支出", category: "社会保険料" },
  { label: "国民年金保険料", type: "支出", category: "社会保険料" },
  { label: "フリラボ", type: "支出", category: "社会保険料" },
  { label: "確定拠出年金", type: "支出", category: "確定拠出年金" },
  { label: "旅費", type: "支出", category: "旅費・交通費" },
  { label: "交通費", type: "支出", category: "旅費・交通費" },
  { label: "学習費", type: "支出", category: "学習費" },
  { label: "食費", type: "支出", category: "食費" },
  { label: "外食費", type: "支出", category: "食費" },
  { label: "外食費（職場関連）", type: "支出", category: "食費" },
  { label: "日用品費", type: "支出", category: "日用品・消耗品費" },
  { label: "消耗品費", type: "支出", category: "日用品・消耗品費" },
  { label: "接待費", type: "支出", category: "接待・交際費" },
  { label: "交際費", type: "支出", category: "接待・交際費" },
  { label: "医療費", type: "支出", category: "医療費" },
  { label: "美容費", type: "支出", category: "美容・被服費" },
  { label: "被服費", type: "支出", category: "美容・被服費" },
  { label: "特別費", type: "支出", category: "特別・臨時費" },
  { label: "臨時費", type: "支出", category: "特別・臨時費" },
  { label: "娯楽費", type: "支出", category: "娯楽費" },
];
